export default function WhatClientGets() {
  const values = [
    {
      icon: 'ri-focus-3-line',
      title: 'Системный взгляд',
      desc: 'Не разрозненные тренинги, а целостная картина: где компания находится сейчас, какие точки роста есть и как выстроить систему обучения для достижения бизнес-целей.'
    },
    {
      icon: 'ri-tools-fill',
      title: 'Реальные инструменты',
      desc: 'Скрипты, чек-листы, регламенты, книги продаж — всё, что остаётся в компании после обучения и продолжает работать без тренера.'
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Адаптацию программы',
      desc: 'Никаких шаблонных решений. Программа разрабатывается под специфику отрасли, продукта, цикла продаж и текущих задач конкретной компании.'
    },
    {
      icon: 'ri-rocket-2-line',
      title: 'Внедрение',
      desc: 'Обучение, которое не остаётся в конспектах. План внедрения, контрольные точки, работа с сопротивлением изменениям.'
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Сопровождение',
      desc: 'Регулярные встречи, аудит, обратная связь, корректировка инструментов. От 1 до 6 месяцев после тренинга.'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Измеримый результат',
      desc: 'Фиксация KPI до начала работы, промежуточные замеры, итоговый отчёт. Рост конверсии, увеличение среднего чека, сокращение цикла сделки.'
    }
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Что получает клиент
          </h2>

        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {values.map((item, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-6 md:p-7 hover:shadow-md transition-all duration-300 group cursor-default">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-teal-600 transition-colors duration-300">
                  <i className={`${item.icon} text-xl text-teal-600 group-hover:text-white transition-colors duration-300`}></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}